import {useSelector} from 'react-redux';
import {get} from 'lodash';

import {MetricsSection} from '/constant/TestIDs';
import {
  REPORT_ALL_ORGANIZATION_ORDERS,
  REPORT_PROJECTED_PREMIER_VOLUME,
} from '/enum/records.enum';
import {useTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';

import {getEstimatedVolumeItem} from './PremierVolumeSection.util';

export function usePremierVolumeSection({
  metrics,
  currentUserCompetency,
  onShowInfoPopover,
  onShowReport,
}: any) {
  const {tt, ts} = useTranslation('screen.clients.section.premierVolume');
  const featureFlag = useSelector(variablesFeatureFlag);
  const updatePremierPlus = shouldReleaseFeature(
    get(featureFlag, 'ff_Premier_Plus', ''),
  );
  const updatedTitle = updatePremierPlus ? 'Premier+' : 'Premier';

  const listItems = [
    {
      label: tt('current', 'Current Month to Date Volume'),
      value: metrics.currentVolume,
      recordsName: REPORT_ALL_ORGANIZATION_ORDERS,
      truncate: true,
      testID: MetricsSection.metricCurrentMonthToDateVolume,
    },
    {
      label: updatePremierPlus
        ? tt('projected', 'Autoship Left This Month')
        : tt('projected', 'Premier Left This Month'),
      value: metrics.projectedVolume,
      recordsName: REPORT_PROJECTED_PREMIER_VOLUME,
      truncate: true,
      testID: MetricsSection.metricProjectedPremierVolume,
    },
    getEstimatedVolumeItem({currentUserCompetency, metrics, tt}),
  ];

  const onInfoPress = () =>
    onShowInfoPopover({
      heading: tt('info.heading', `Projected ${updatedTitle} Volume`),
      body: tt(
        'info.body',
        `This report shows projected volume from scheduled ${updatedTitle} orders (orders yet to process this month). This volume isn't guaranteed - just what is scheduled to process through the end of the month.`,
      ),
    });

  const onItemPress = ({recordsName}: any) => {
    // On the Project Premier Volume section we don't pass the totals through
    // like the other sections, because we don't want them to appear on the report ui
    onShowReport({recordsName});
  };

  return {listItems, onInfoPress, onItemPress, tt, ts};
}
